{
  "types": {
    "ASSET": "Asset",
    "LIABILITY": "Liability",
    "EQUITY": "Equity",
    "REVENUE": "Revenue",
    "EXPENSE": "Expense"
  },
  "fields": {
    "code": "Code",
    "name": "Name",
    "nameAr": "Name in Arabic",
    "type": "Type",
    "parent": "Parent account",
    "isPostable": "Entries can be posted to this account",
    "roles": "Used for"
  },
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "You have changes on this page that haven't been saved.",
    "confirm": "Discard changes",
    "cancel": "Keep editing"
  },
  "errors": {
    "SYSTEM_ACCOUNT": "This is a system account: its type and posting setting can't change, and it can't be archived.",
    "ACCOUNT_HAS_POSTINGS": "This account already has journal entries, so its type and posting setting can no longer change.",
    "ACCOUNT_HAS_CHILDREN": "This account has sub-accounts. Archive or move them first.",
    "ACCOUNT_IN_USE": "This account is mapped to an accounting role. Choose another account for that role first (Account mapping).",
    "TREASURY_GL_ACCOUNT": "This account belongs to a cash or bank account, so it stays as it is. Archive the cash or bank account under Cash & bank instead.",
    "TILL_DRAWER_ACCOUNT": "This cash account is the drawer of till {{tills}}: take money in or out at the till (pay in / pay out), or choose another account.",
    "DRAWER_SHIFT_OPEN": "Shift {{shifts}} is open on till {{tills}}, and this would move its drawer. Use pay in / pay out at the till, or wait until the shift is closed.",
    "PERIOD_CLOSED": "The fiscal year for this date is closed. Choose a date in an open year.",
    "NO_FISCAL_YEAR": "No fiscal year covers this date. Create the fiscal year first.",
    "CANNOT_REVERSE_REVERSAL": "A reversing entry can't itself be reversed.",
    "REVERSAL_BEFORE_ORIGINAL": "The reversal can't be dated before the entry it reverses.",
    "ACCOUNT_ROLE_NOT_CONFIGURED": "An accounting role this needs has no account yet. Set it up in Account mapping.",
    "INVALID_POSTING": "The entry can't be posted as it is. Check the accounts and amounts on each line."
  },
  "chart": {
    "title": "Chart of accounts",
    "subtitle": "The accounts your entries post to, grouped under header accounts.",
    "new": "New account",
    "newTitle": "New account",
    "newSubtitle": "Add a posting account, or a header to group accounts under.",
    "editTitle": "Edit account",
    "save": "Save account",
    "actions": "Actions",
    "header": "{{type}} header",
    "archived": "Archived",
    "systemAccount": "System account",
    "systemNotice": "This is a system account. You can rename it; its type and posting setting are fixed.",
    "searchLabel": "Search accounts",
    "searchPlaceholder": "Search code or name…",
    "clearSearch": "Clear search",
    "showArchived": "Show archived",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "addUnder": "Add an account under {{name}}",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "restoreNamed": "Restore {{name}}",
    "searchAccounts": "Search code or name…",
    "noAccounts": "No accounts found.",
    "noHeaders": "No header accounts of this type.",
    "noParent": "No parent (top level)",
    "clearParent": "Move to the top level",
    "hints": {
      "type": "Decides the side the account increases on and where it appears in reports.",
      "systemType": "System accounts keep their type.",
      "parent": "Only header accounts of the same type can hold sub-accounts.",
      "postable": "A posting account: journal lines can use it.",
      "header": "A header account: it only groups sub-accounts and totals them in reports."
    },
    "errors": {
      "codeTaken": "Another account already has this code.",
      "parent": "Choose a header account of the same type.",
      "version": "Someone else changed this account. Close this panel and open the account again."
    },
    "archive": {
      "title": "Archive account {{code}}?",
      "body": "It can no longer be posted to. Its history stays in reports, and you can restore it later.",
      "confirm": "Archive"
    },
    "restore": {
      "title": "Restore account {{code}}?",
      "body": "It can be posted to again.",
      "confirm": "Restore"
    },
    "toast": {
      "created": "Account {{code}} created",
      "updated": "Account saved",
      "archived": "Account archived",
      "restored": "Account restored"
    },
    "empty": {
      "title": "No accounts yet.",
      "filtered": "No accounts match.",
      "filteredBody": "Try another code or name."
    }
  },
  "mapping": {
    "title": "Account mapping",
    "subtitle": "Which account each kind of posting uses. Documents post to these accounts automatically.",
    "role": "Used for",
    "expectedType": "Account type",
    "account": "Account",
    "accountFor": "Account for {{role}}",
    "choose": "Choose an account",
    "search": "Search code or name…",
    "noAccounts": "No active {{type}} posting accounts.",
    "notMapped": "No account chosen",
    "none": "No roles to map.",
    "save": "Save mapping",
    "saved": "Account mapping saved",
    "unmappedTitle_one": "{{n}} role has no account",
    "unmappedTitle_other": "{{n}} roles have no account",
    "unmappedBody": "Documents that need these roles can't be posted until each has an account.",
    "pending_one": "{{n}} unsaved change",
    "pending_other": "{{n}} unsaved changes",
    "errors": {
      "rows": "Some accounts can't be used. Check the highlighted rows.",
      "invalid": "Choose an active posting account of the right type."
    }
  },
  "journals": {
    "title": "Journal entries",
    "subtitle": "Every posting to the ledger, manual and from documents.",
    "new": "New journal entry",
    "newTitle": "New journal entry",
    "newSubtitle": "A manual entry: debits must equal credits.",
    "post": "Post entry",
    "saveHint": "Press {{shortcut}} to post",
    "kindFilter": "Filter by kind",
    "allKinds": "All kinds",
    "accountFilter": "Filter by account",
    "allAccounts": "All accounts",
    "clearFilters": "Clear filters",
    "lines": "Lines",
    "linesHint": "At least two lines. Each line has either a debit or a credit.",
    "lineActions": "Line actions",
    "addLine": "Add line",
    "removeLine": "Remove line {{n}}",
    "enterHint": "Press Enter on the last line to add another.",
    "chooseAccount": "Choose an account",
    "accountOfLine": "Account, line {{n}}",
    "descriptionOfLine": "Description, line {{n}}",
    "debitOfLine": "Debit, line {{n}}",
    "creditOfLine": "Credit, line {{n}}",
    "totals": "Totals",
    "difference": "Difference",
    "balanced": "Balanced",
    "outOfBalance": "Out of balance by",
    "reversedTitle": "This entry was reversed",
    "reversedBy": "Reversed by",
    "reversalOf": "This entry reverses",
    "sections": {
      "entry": "Entry"
    },
    "fields": {
      "number": "Number",
      "date": "Date",
      "kind": "Kind",
      "reference": "Reference",
      "description": "Description",
      "total": "Total",
      "status": "Status",
      "account": "Account",
      "lineDescription": "Line description",
      "debit": "Debit",
      "credit": "Credit",
      "source": "Source",
      "postedAt": "Posted"
    },
    "kind": {
      "MANUAL": "Manual",
      "SYSTEM": "From a document",
      "REVERSAL": "Reversal",
      "OPENING": "Opening balance",
      "CLOSING": "Year-end closing"
    },
    "status": {
      "POSTED": "Posted",
      "REVERSED": "Reversed"
    },
    "source": {
      "Expense": "Expense",
      "TreasuryTransfer": "Cash or bank transfer",
      "TreasuryAccount": "Opening balance of a cash or bank account",
      "Purchase": "Purchase",
      "SupplierPayment": "Supplier payment",
      "SupplierReturn": "Supplier return",
      "CustomerRefund": "Customer refund",
      "PosSale": "Till sale",
      "PosShift": "Till shift (cash over or short)",
      "SupplierRefund": "Supplier refund",
      "BankStatement": "Bank reconciliation"
    },
    "empty": {
      "title": "No journal entries yet.",
      "body": "Post a manual entry, or record documents that post automatically.",
      "filteredTitle": "No entries match.",
      "filteredBody": "Try another period, kind or account, or clear the filters."
    },
    "errors": {
      "notPosted": "The entry wasn't posted",
      "unbalanced": "Debits ({{debit}}) and credits ({{credit}}) must be equal and above zero."
    },
    "toast": {
      "posted": "Entry {{number}} posted"
    },
    "reverse": {
      "action": "Reverse",
      "title": "Reverse {{number}}?",
      "body": "A new entry with the debits and credits swapped cancels this one. Both stay in the books.",
      "reason": "Reason",
      "date": "Reversal date",
      "dateHint": "On or after {{date}}, the date of the entry.",
      "confirm": "Reverse entry",
      "done": "Reversal {{number}} posted",
      "already": "This entry has already been reversed. Reload to see the reversal."
    },
    "stats": {
      "label": "Journal figures",
      "posted": "Posted this month",
      "postedDetail": "{{month}} · {{entries}}",
      "trend": "Journal entries by month, {{from}} to {{to}}",
      "manual": "Manual entries",
      "system": "From documents",
      "reversals": "Reversals",
      "totalDetail": "{{amount}} in total",
      "entries_one": "{{n}} entry",
      "entries_other": "{{n}} entries"
    }
  },
  "trialBalance": {
    "title": "Trial balance",
    "account": "Account",
    "opening": "Opening balance",
    "period": "Movement",
    "closing": "Closing balance",
    "debit": "Debit",
    "credit": "Credit",
    "totals": "Totals",
    "hideZero": "Hide accounts with no balance",
    "balanced": "Debits equal credits",
    "unbalanced": "Out of balance by {{amount}}",
    "empty": "Nothing posted for this period.",
    "emptyBody": "Choose another period, or turn off “Hide accounts with no balance”.",
    "invalidRange": "The end date is before the start date.",
    "printedAt": "Printed {{at}}",
    "hint": "Amounts in <rial/>. Select an account to see its entries for the period. Today is {{today}}."
  },
  "fiscalYears": {
    "title": "Fiscal years",
    "subtitle": "The periods entries are posted in. Every entry date must fall in an open year.",
    "new": "New fiscal year",
    "newTitle": "New fiscal year",
    "newSubtitle": "Usually the year after the latest one.",
    "save": "Create fiscal year",
    "current": "Current",
    "hint": "Fiscal years can't overlap. Without one, a calendar year is created automatically when its first entry is posted.",
    "fields": {
      "name": "Name",
      "startDate": "Starts",
      "endDate": "Ends",
      "status": "Status"
    },
    "status": {
      "OPEN": "Open",
      "CLOSED": "Closed"
    },
    "empty": {
      "title": "No fiscal years yet.",
      "body": "Calendar years are created automatically with the first entry of each year. Create one here to use a different fiscal year."
    },
    "errors": {
      "overlap": "This period overlaps an existing fiscal year.",
      "endBeforeStart": "The end date must be after the start date."
    },
    "toast": {
      "created": "{{name}} created"
    }
  }
}
